/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_TitleInputs */

const en_merge_swal_title = /** @type {(inputs: Merge_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Events`)
};

const fr_merge_swal_title = /** @type {(inputs: Merge_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner les Evenements`)
};

const de_merge_swal_title = /** @type {(inputs: Merge_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführungsereignisse`)
};

const it_merge_swal_title = /** @type {(inputs: Merge_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci eventi`)
};

const ru_merge_swal_title = /** @type {(inputs: Merge_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слияние событий`)
};

const es_merge_swal_title = /** @type {(inputs: Merge_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar eventos`)
};

const zh_cn2_merge_swal_title = /** @type {(inputs: Merge_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并事件`)
};

const ja_merge_swal_title = /** @type {(inputs: Merge_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントをマージする`)
};

const hi_merge_swal_title = /** @type {(inputs: Merge_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विलय घटनाएँ`)
};

const pt_pt2_merge_swal_title = /** @type {(inputs: Merge_Swal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar eventos`)
};

/**
* | output |
* | --- |
* | "Merge Events" |
*
* @param {Merge_Swal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_title = /** @type {((inputs?: Merge_Swal_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_swal_title(inputs)
	if (locale === "de") return de_merge_swal_title(inputs)
	if (locale === "it") return it_merge_swal_title(inputs)
	if (locale === "ru") return ru_merge_swal_title(inputs)
	if (locale === "es") return es_merge_swal_title(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_swal_title(inputs)
	if (locale === "ja") return ja_merge_swal_title(inputs)
	if (locale === "hi") return hi_merge_swal_title(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_swal_title(inputs)
	return en_merge_swal_title(inputs)
});